export const eva_constants = {
  EVA_THEME: 'eva',
  MYLIVETV_THEME: 'mylivetv',
  LIVEE_THEME: 'livee',

  HOST_MYLIVE: 'mylive',
  HOST_LIVEE: 'livee.app',
  
  ACCOUNT_TYPE_TAG: 'account.type',
  ACCOUNT_DISPLAYNAME_TAG: 'account.displayname',
  ACCOUNT_TOPICS_TAG: 'account.topics',
  SESSION_TYPE_TAG: 'session.type'
};



// WEBPACK FOOTER //
// ./src/app/eva_constants.ts